import React from "react";

const Loader = () => {
  return (

    <div>
      <div id="global-loader">
        <img
          src="https://cdn.adgebra.net/custom/adgLoader/loader.png"
          style={{
            position: "absolute",
            position: "absolute",
            top: "0",
            bottom: "0",
            margin: "auto",
            width: "50%",
            // scale: "0.8",
          }}
          className="loader-img"
          alt="Loading.."
        />
      </div>
    </div>
  );
};

export default Loader;
